import { EffectsEnum } from "../../shared/types/EffectsEnum.ts";
import { ApiClient } from "../../shared/api/apiClient.ts";
import { TGeneration, TGenerationServer } from "../../shared/types/GenerationType.ts";
import {GenerationStatusEnum} from "../../shared/types/GenerationStatusEnum.ts";


export class GenerationApi extends ApiClient {

    constructor() {
        super()
    }

    public async startGeneration(initialImageBase64: string, effect: EffectsEnum, prompt: string): Promise<TGeneration> {
        const response = await this.post<TGenerationServer>('/generations/start', {
            initialImageBase64,
            effect,
            prompt
        });
        return this.generationServerToFront(response);
    }

    public async getGenerationsStatus(
        generations: TGeneration[]
    ): Promise<TGeneration[]> {
        const updatedGenerations: TGeneration[] = await Promise.all(
            generations.map(generation => this.getGenerationStatusById(generation.id))
        );
        return updatedGenerations
    }

    public async getAllGenerations() {
        const response = await this.get<TGenerationServer[]>('/generations/all');
        if (!Array.isArray(response)) {
            return [];
        }
        return Promise.all(response.map((gen) => this.generationServerToFront(gen)));
    }

    public async downloadGeneration(generationId: number) {
        await this.post(`/generations/${generationId}/download`);
    }

    private async getGenerationStatusById(generationId: number): Promise<TGeneration> {
        const response = await this.get<TGenerationServer>(`/generations/${generationId}/status`);
        return this.generationServerToFront(response);
    }

    private async generationServerToFront(generation: TGenerationServer): Promise<TGeneration> {
        switch (generation.status) {
            case GenerationStatusEnum.FAILED:
                return {
                    id: generation.id,
                    status: generation.status,
                    type: generation.generationType,
                    error: generation.errorText
                }
            case GenerationStatusEnum.PROCESSING:
                return {
                    id: generation.id,
                    status: generation.status,
                    type: generation.generationType,
                }
            case GenerationStatusEnum.GENERATED:
                return {
                    id: generation.id,
                    status: generation.status,
                    resultSrc: generation.resultUrl,
                    previewSrc: generation.previewUrl,
                    type: generation.generationType ? generation.generationType : undefined
                };
        }

    }
}
